import { ItemType, OutlineSetType } from '../enums';

/**
 * A round element is a solid shape with an outline and dimensions only: it has no
 * fronts, frames, layout, articles, fillers, boards or configuration options, and the
 * backend refuses every cabinet-only call on it.
 */
export const isRoundElement = (item: { itemType?: ItemType | string } | null | undefined): boolean =>
	item?.itemType === ItemType.ROUND_ELEMENT;

/** The kind of outline set an item is built from. */
export const outlineSetTypeOf = (item: { itemType?: ItemType | string } | null | undefined): OutlineSetType =>
	isRoundElement(item) ? OutlineSetType.ROUND_ELEMENT : OutlineSetType.CABINET;
